import { createContext, useContext, useEffect, useRef, useState } from "react";
import { PocketBaseClient } from "../Api/PocketbaseClient.js";

type SystemStatus = "UP" | "DOWN" | "MAINTENANCE";

const SystemStatusContext = createContext<{
  status: SystemStatus | null;
  statusMessage: string | null;
  isLoading: boolean;
}>({
  status: null,
  statusMessage: null,
  isLoading: true,
});

export const SystemStatusProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const loadRef = useRef<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [systemStatus, setSystemStatus] = useState<SystemStatus | null>(null);
  const [systemStatusMessage, setSystemStatusMessage] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (loadRef.current) return;
    loadRef.current = true;

    PocketBaseClient.collection("system")
      .getFullList(1, { fields: "status,statusMessage" })
      .then((items) => {
        setSystemStatus(items[0]?.status);
        setSystemStatusMessage(items[0]?.statusMessage);
        setIsLoading(false);
      });
  }, [systemStatus, systemStatusMessage]);

  return (
    <SystemStatusContext.Provider
      value={{
        status: systemStatus,
        statusMessage: systemStatusMessage,
        isLoading,
      }}
    >
      {children}
    </SystemStatusContext.Provider>
  );
};

export const useSystemStatus = () => {
  const context = useContext(SystemStatusContext);
  if (!context) {
    throw new Error(
      "useSystemStatus must be used within a SystemStatusProvider"
    );
  }
  return context;
};
